const DAY_IN_SECONDS = 86_400;

export const readCookie = (name: string): string | null => {
  if (typeof document === "undefined") return null;

  for (const pair of document.cookie.split(";")) {
    const [cookieName, ...valueParts] = pair.trim().split("=");

    if (cookieName === name) {
      return decodeURIComponent(valueParts.join("="));
    }
  }

  return null;
};

export const writeCookie = (
  name: string,
  value: string,
  maxAgeDays: number
): void => {
  if (typeof document === "undefined") return;

  const maxAge = maxAgeDays * DAY_IN_SECONDS;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
};

export const removeCookie = (name: string): void => writeCookie(name, "", 0);
